import { Types } from "../actions/userActions";

const initialState = {
    userRecords: {},
    plants: {},
    updateRecord: {},
    userInformation: {},
    userInformationLoading: true,
    userPicture: "",
    userPictureLoading: true,
    userPlantList: {},
    userMenuList: [],
    userInterfaceList: [],
    showMessage: {},
    userDetail: {},
    userGroupList: [],
    userRoleGroupList: [],
    userGroupbyId: {},
    userRoleGroupbyID: {},
    userTechListByPoolID: [],
    technicianList: null,
    isTaskUpdatedUser: false,
    userRole: false,
    costCenters: {},
    eqReportList: {},
    maintenanceApproval: {},
};

export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_USER_LIST:
            return {
                ...state,
                userRecords: action.payload || state.userRecords,
            };
        case Types.SET_PLANTS_FOR_USER:
            return {
                ...state,
                plants: action.payload || state.plants,
            };
        case Types.SET_PLANTS_FOR_USER_PAGE:
            return {
                ...state,
                userPagePlants: action.payload || state.userPagePlants,
            };
        case Types.RESET_USER_LIST:
            return {
                ...state,
                userRecords: {},
            };
        case Types.SET_USER_INFORMATION:
            return {
                ...state,
                //   userInformation: action.payload || state.userInformation,
                userInformation: action.resultObject || state.userInformation,
                userInformationLoading: false,
            };

        case Types.SET_USER_INFO: // just import this and use it . action with above type is not declared
            return {
                ...state,
                userInformation: action.payload || state.userInformation,
                //   userInformation: action.resultObject || state.userInformation,
                userInformationLoading: false,
            };

        case Types.SET_USER_PLANT_LIST:
            return {
                ...state,
                userPlantList: action.payload || state.userPlantList,
            };

        case Types.SET_USER_MENU_LIST: {
            return {
                ...state,
                userMenuList: action.payload || state.userMenuList,
            };
        }
        case Types.SET_USER_INTERFACE_LIST: {
            return {
                ...state,
                userInterfaceList: action.payload || state.userInterfaceList,
            };
        }

        case Types.SET_SHOW_MESSAGE: {
            return {
                ...state,
                showMessage: action.payload || state.showMessage,
            };
        }

        case Types.SET_USER_DETAIL_BY_ID: {
            return {
                ...state,
                userDetail: action.payload,
            };
        }
        case Types.SET_USER_GROUP_LIST: {
            return {
                ...state,
                userGroupList: action.payload,
            };
        }
        case Types.SET_USER_ROLE_GROUP_LIST: {
            return {
                ...state,
                userRoleGroupList: action.payload,
            };
        }
        case Types.SET_USER_GROUP_BY_ID: {
            return {
                ...state,
                userGroupbyId: action.payload,
            };
        }
        case Types.SET_USER_ROLE_GROUP_BY_ID: {
            return {
                ...state,
                userRoleGroupbyID: action.payload,
            };
        }
        case Types.SET_TECHNICIAN_LIST_BY_POOL_ID: {
            return {
                ...state,
                userTechListByPoolID: action.payload,
            };
        }
        case Types.SET_TECHNICIAN_LIST:
            return {
                ...state,
                technicianList: action.payload,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedUser: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedUser: false,
            };
        case Types.SET_CHECK_USER_ROLE:
            return {
                ...state,
                userRole: action.payload,
            };
        case Types.SET_COST_CENTER_FOR_USER:
            return {
                ...state,
                costCenters: action.payload || state.costCenters,
            };
        case Types.SET_EQUIPMENT_REPORT_GROUP_LIST_FOR_USER:
            return {
                ...state,
                eqReportList: action.payload || state.eqReportList,
            };
        case Types.SET_MAINTENANCE_APPROVAL:
            return {
                ...state,
                maintenanceApproval: action.payload || state.maintenanceApproval,
            };
        default:
            return state;
    }
};
